import React from 'react';
// mui componets
import { Grid, Avatar, Typography } from '@mui/material';
// components
import DefaultAvatar from 'components/default-avatar';
// draft-js-plugins types
import { EntryComponentProps } from '@draft-js-plugins/mention/lib/MentionSuggestions/Entry/Entry';
// utils
import { getImageBySize } from 'utils/helpers';

const Entry: React.FC<EntryComponentProps> = ({
  mention,
  theme,
  searchValue,
  isFocused,
  selectMention,
  ...props
}) => {
  return (
    <Grid
      {...props}
      sx={{
        display: 'flex',
        width: '280px',
        flexDirection: 'row',
        gap: '12px',
        padding: '12px 16px',
      }}
    >
      <Grid
        sx={{
          display: 'flex',
          height: '40px',
          width: '40px',
          position: 'relative',
        }}
      >
        {mention?.avatar ? (
          <Avatar
            alt="avatar"
            sx={{ width: '40px', height: '40px', borderRadius: '8px' }}
            src={getImageBySize(mention.avatar, 40, 40, false)}
            variant="square"
          />
        ) : (
          <DefaultAvatar
            initials={`${mention?.firstName?.[0]}${mention.lastName?.[0]}`}
            alt="avatar"
            variant="square"
            sx={{ borderRadius: '4px', width: '40px', height: '40px' }}
          />
        )}
      </Grid>
      <Grid sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '146%',
            color: '#23252F',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '1',
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-all',
          }}
        >
          {mention.name}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: '12px',
            lineHeight: '150%',
            color: '#23252F',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '1',
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-all',
          }}
        >
          {mention?.email}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Entry;
